import React, {Component} from 'react'
import {Row, Col, Form, FormGroup, Label, Input, FormText, Button} from 'reactstrap'
import {
    AvForm,
    AvField,
} from 'availity-reactstrap-validation'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {toast} from 'react-toastify'
import moment from 'moment'

import AUSelectGenerator from '../components/auto_updaters/ValidSelect'
import ProjectDisciplinesTypeahead from '../components/project/ProjectDisciplinesTypeahead'

import upsertProjectDetailMutation from '../../queries/server/mutations/upsert_project_detail'
import editProjectLocalMutation from '../../queries/client_side/mutations/edit_project'
import ProjectContractStatusNoteCreateModal from "./project/ProjectContractStatusNoteCreateModal";

const AUSelectProjectStatuses = AUSelectGenerator('project_statuses', 'project_status_id description', 'project_status_id', ['description'])
const AUSelectProjectContractStatuses = AUSelectGenerator('project_contract_statuses', 'id description', 'id', ['description'])
const AUSelectUsers = AUSelectGenerator('active_users', 'user_id first_name last_name', 'user_id', ['first_name', 'last_name'])
const AUSelectLandUses = AUSelectGenerator('project_land_uses', 'project_land_use_id description', 'project_land_use_id', ['description'])

export default class ProjectForm extends Component {

    constructor(props) {
        super(props)

        const {
            project_id,
            name,
            description,
            project_status_id,
            project_director_id,
            project_manager_id,
            lead_technician_id,
            land_use_id,
            rate_type_id,
            project_associated_disciplines,
            contract_status_id,
            project_status_updated_at,
            onChange
        } = props

        this.state = {
            project_id,
            name,
            description: description || '',
            project_status_id,
            rate_type_id,
            project_director_id: project_director_id || '',
            project_manager_id: project_manager_id || '',
            lead_technician_id: lead_technician_id || '',
            land_use_id: land_use_id || '',
            contract_status_id: contract_status_id || '',
            project_associated_disciplines,
            project_status_updated_at,
            contractStatusNoteModalOpen: false
        }

        //this.save = _.debounce(this.save, 1000)
    }

    toggleContractStatusNoteModal = () => {
        this.setState({contractStatusNoteModalOpen: !this.state.contractStatusNoteModalOpen})
    }

    save = (mutationFunc, data, editProjectMutationFunc) => {

        const {
            project_id,
            name,
            description,
            project_status_id,
            rate_type_id,
            project_director_id,
            project_manager_id,
            lead_technician_id,
            land_use_id,
            project_associated_disciplines,
            contract_status_id
        } = data


        mutationFunc({
            variables: {
                project_id,
                data: {
                    project_id,
                    name,
                    description,
                    project_status_id,
                    rate_type_id,
                    project_director_id: project_director_id || null,
                    project_manager_id: project_manager_id || null,
                    lead_technician_id: lead_technician_id || null,
                    land_use_id: land_use_id || null,
                    contract_status_id: contract_status_id || null,
                    project_associated_disciplines
                }
            }
        })
            .then(({data}) => {
                editProjectMutationFunc({variables: {data: data.upsertProjectDetail}})
                //toast.success('Successfully Saved!', {autoClose: 2000})
            })
            .catch(e => {
                toast(e.message, {autoClose: false})
            })
    }


    render() {

        const {
            project_id,
            name,
            description,
            project_status_id,
            project_director_id,
            project_manager_id,
            lead_technician_id,
            land_use_id,
            project_associated_disciplines,
            contract_status_id,
            project_status_updated_at
        } = this.state

        return (
            <Mutation mutation={editProjectLocalMutation}>
                {(editProjectLocalMutationFunc) => (
                    <Mutation mutation={upsertProjectDetailMutation}>
                        {(upsertProjectDetailMutationFunc, {loading}) => (
                            <div>
                                <AvForm onValidSubmit={() => {
                                    const {
                                        project_id,
                                        name,
                                        description,
                                        project_status_id,
                                        rate_type_id,
                                        project_director_id,
                                        project_manager_id,
                                        lead_technician_id,
                                        land_use_id,
                                        project_associated_disciplines,
                                        contract_status_id
                                    } = this.state


                                    upsertProjectDetailMutationFunc({
                                        variables: {
                                            project_id,
                                            data: {
                                                project_id,
                                                name,
                                                description,
                                                project_status_id,
                                                rate_type_id,
                                                project_director_id: project_director_id || null,
                                                project_manager_id: project_manager_id || null,
                                                lead_technician_id: lead_technician_id || null,
                                                land_use_id: land_use_id || null,
                                                contract_status_id: contract_status_id || null,
                                                project_associated_disciplines
                                            }
                                        }
                                    })
                                        .then(({data}) => {
                                            editProjectLocalMutationFunc({variables: {data: data.upsertProjectDetail}})
                                            toast.success('Successfully Saved!', {autoClose: 2000})
                                        })
                                        .catch(e => {
                                            toast.error(e.message, {autoClose: false})
                                        })
                                }}>

                                    <div className="form-row">
                                        <Col>
                                            <AvField
                                                required
                                                label="Name*"
                                                errorMessage="Required"
                                                type="text"
                                                name="name"
                                                id="name"
                                                className="form-control-sm"
                                                value={name}
                                                onChange={evt => {
                                                    const name = evt.target.value
                                                    /*this.setState({name}, () => this.save(upsertProjectDetailMutationFunc, {
                                                        ...this.state,
                                                        name
                                                    }, editProjectLocalMutationFunc))*/
                                                    this.setState({name})

                                                }}
                                            />
                                        </Col>
                                        <Col>
                                            <AUSelectProjectStatuses
                                                required
                                                label={`Status* (Last Update: ${moment(project_status_updated_at).format('DD/MM/YYYY')})`}
                                                name="project_status_id"
                                                id="project_status_id"
                                                errorMessage="Required"
                                                onChange={project_status_id => {
                                                    /*this.setState({project_status_id}, () => this.save(upsertProjectDetailMutationFunc, {
                                                        ...this.state,
                                                        project_status_id
                                                    }, editProjectLocalMutationFunc))*/

                                                    this.setState({project_status_id})

                                                }}
                                                value={project_status_id}
                                                className="form-control-sm"
                                            />
                                        </Col>
                                    </div>

                                    <div className="form-row">
                                        <Col>
                                            <FormGroup>
                                                <Label for="description">Description</Label>
                                                <Input
                                                    type="textarea"
                                                    name="description"
                                                    id="description"
                                                    placeholder="Description"
                                                    className="form-control-sm"
                                                    value={description}
                                                    onChange={evt => {
                                                        const description = evt.target.value
                                                        /*this.setState({description}, () => this.save(upsertProjectDetailMutationFunc, {
                                                            ...this.state,
                                                            description
                                                        }, editProjectLocalMutationFunc))*/
                                                        this.setState({description})

                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </div>

                                    <div className="form-row">
                                        <Col>
                                            <FormGroup>
                                                <Label for="project_director_id">Director</Label>
                                                <AUSelectUsers
                                                    name="project_director_id"
                                                    id="project_director_id"
                                                    onChange={project_director_id => {
                                                        /*this.setState({project_director_id}, () => this.save(upsertProjectDetailMutationFunc, {
                                                            ...this.state,
                                                            project_director_id
                                                        }, editProjectLocalMutationFunc))*/

                                                        this.setState({project_director_id})

                                                    }}
                                                    value={project_director_id}
                                                    className="form-control-sm"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label for="project_manager_id">Lead Engineer</Label>
                                                <AUSelectUsers
                                                    name="project_manager_id"
                                                    id="project_manager_id"
                                                    onChange={project_manager_id => {
                                                        /*this.setState({project_manager_id}, () => this.save(upsertProjectDetailMutationFunc, {
                                                            ...this.state,
                                                            project_manager_id
                                                        }, editProjectLocalMutationFunc))*/

                                                        this.setState({project_manager_id})

                                                    }}
                                                    value={project_manager_id}
                                                    className="form-control-sm"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label for="lead_technician_id">Lead Technician</Label>
                                                <AUSelectUsers
                                                    name="lead_technician_id"
                                                    id="lead_technician_id"
                                                    onChange={lead_technician_id => {
                                                        /*this.setState({lead_technician_id}, () => this.save(upsertProjectDetailMutationFunc, {
                                                            ...this.state,
                                                            lead_technician_id
                                                        }, editProjectLocalMutationFunc))*/

                                                        this.setState({lead_technician_id})

                                                    }}
                                                    value={lead_technician_id}
                                                    className="form-control-sm"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </div>

                                    <div className="form-row">
                                        <Col>
                                            <FormGroup>
                                                <Label for="disciplines">Disciplines</Label>
                                                <ProjectDisciplinesTypeahead
                                                    selected={project_associated_disciplines}
                                                    onChange={project_associated_disciplines => {
                                                        /*this.setState({lead_technician_id}, () => this.save(upsertProjectDetailMutationFunc, {
                                                            ...this.state,
                                                            project_associated_disciplines
                                                        }, editProjectLocalMutationFunc))*/
                                                        this.setState({project_associated_disciplines})

                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label for="land_use_id">Land Use</Label>
                                                <AUSelectLandUses
                                                    name="land_use_id"
                                                    id="land_use_id"
                                                    onChange={land_use_id => {
                                                        /*this.setState({land_use_id}, () => this.save(upsertProjectDetailMutationFunc, {
                                                            ...this.state,
                                                            land_use_id
                                                        }, editProjectLocalMutationFunc))*/

                                                        this.setState({land_use_id})

                                                    }}
                                                    value={land_use_id}
                                                    className="form-control-sm"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label for="land_use_id">Contract Status</Label>
                                                <AUSelectProjectContractStatuses
                                                    name="contract_status_id"
                                                    id="contract_status_id"
                                                    onChange={contract_status_id => {
                                                        this.setState({contract_status_id}, () => this.save(upsertProjectDetailMutationFunc, {
                                                            ...this.state,
                                                            contract_status_id
                                                        }, editProjectLocalMutationFunc))
                                                        this.toggleContractStatusNoteModal()
                                                    }}
                                                    value={contract_status_id}
                                                    className="form-control-sm"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </div>

                                    <div className="d-flex justify-content-end align-content-end" style={{flex: 1}}>
                                        <Button
                                            size="sm"
                                            color="success"
                                            disabled={loading}

                                        >
                                            <FontAwesomeIcon
                                                color="#fff"
                                                icon={loading ? 'spinner' : 'save'}
                                                spin={loading}
                                            />{' '}
                                            {loading ? 'Saving...' : 'Save Project'}
                                        </Button>
                                    </div>
                                </AvForm>
                                <ProjectContractStatusNoteCreateModal
                                    toggle={this.toggleContractStatusNoteModal}
                                    isOpen={this.state.contractStatusNoteModalOpen}
                                    project_id={project_id}
                                />
                            </div>


                        )}
                    </Mutation>)}
            </Mutation>)

    }

}

ProjectForm.propTypes = {
    project_id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    project_status_id: PropTypes.number.isRequired,
    rate_type_id: PropTypes.number.isRequired,
    description: PropTypes.string,
    project_director_id: PropTypes.number,
    project_manager_id: PropTypes.number,
    lead_technician_id: PropTypes.number,
    land_use_id: PropTypes.number,
    project_associated_disciplines: PropTypes.array,

}